// project imports
import PageTitle from './PageTitle';
import Profile from './Profile';
import Notification from './Notification';

// ==============================|| HEADER - CONTENT ||============================== //
// "Download Free Version" GitHub link to the Mantis template repo removed -
// not relevant to do-ra.cz. Search zatím pryč (2026-08-22, na přání
// uživatele - "zatím" = dočasně, Search.jsx zůstává na disku pro budoucí
// znovuzavedení, jen se nikde nerenderuje). Na jeho místo přišel název
// aktuální stránky s ikonou (PageTitle). Profile se teď renderuje vždy
// napřímo (desktop i mobil) - dřív mobil musel nejdřív ťuknout na "..."
// (MobileSection, smazáno), teď otevírá offcanvas-right-user rovnou.
export default function HeaderContent() {
  return (
    <>
      <PageTitle />
      <Notification />
      <Profile />
    </>
  );
}
